// Marketing-editable copy. Anything text-shaped that a marketing team would
// want to A/B test or tweak lives here so the React tree itself doesn't have
// to change.
//
// See frontend/MARKETING.md for the full editor guide.

// The headline is deliberately two parts: a plain statement, then the turn.
// `headlineAccent` renders on its own line in slate-teal — that colour shift is
// the house headline pattern, so keep both halves populated.
export const hero = {
  eyebrow: { from: 'MSG', to: 'PDF' },
  headline: 'Convert MSG to PDF in seconds.',
  headlineAccent: 'Nothing gets lost in translation.',
  description:
    'Fast, secure, online. Convert Outlook .msg, .eml, and .doc files to PDF instantly — ' +
    'headers, formatting, and attachments intact.',
  trustLine: 'No add-ins. No inbox access. Files deleted within 24 hours.',
  ctaPrimary: 'Try 10 conversions free',
};

// Format chips shown under the hero. All render in one uniform style (mono type,
// paper fill, powder hairline) — the brand doesn't color-code file formats, so
// this is a plain list of labels. Add or reorder freely.
export const supportedFormatChips = [
  '.msg', '.eml', '.docx', '.doc', '.jpg', '.png', '.pdf', '+more',
];

export const seoDefaults = {
  title: 'MSG to PDF Converter - Free Online Tool',
  description:
    'Free online MSG to PDF converter. The best tool for converting Outlook emails to PDFs ' +
    'securely. Supports .msg and .eml files. No registration required.',
  ogImagePath: '/logo.png',
  brandName: 'MSG to PDF Converter',
};
